import {useGetLimitsByType, getUsageFromLimits} from '../../../limits';
import type {MonthlyUsage} from '../../../limits/get-usage-from-limits';

export const useGetAgentMonthlyUsage = (): {
    monthlyUsage: MonthlyUsage | null | undefined;
    isLoading: boolean;
    error?: boolean;
    refetch: () => Promise<any>;
} => {
    const {isLoading, limits, errorMessage, refetch} = useGetLimitsByType('AI_CONVERSATIONS');

    const monthlyUsage = getUsageFromLimits(limits);

    return {
        monthlyUsage,
        isLoading,
        error: Boolean(errorMessage || (!isLoading && !monthlyUsage)),
        refetch,
    };
};
